import { PropertySet } from '@miq/domain/property-sets';
import { OpenInNewComponent } from './open-in-new/open-in-new.component';
import { PropertySetStatisticalCellRendererComponent } from './property-set-statistical-cell-renderer-component/property-set-statistical-cell-renderer.component';
import { Column } from '@miq/catalog';
import { getPropertyTypeLabel } from '@miq/utils';

export type ColumnToShow = Pick<Column, 'columnId' | 'field' | 'header' | 'CellRenderer' | 'sortable' | 'displayFn'> & {
  context?: { propertySet: PropertySet };
  dataType?: any;
};

interface RecordSetShortView {
  set_id: string;
}

interface UsageShortView {
  ref_property_usage_type_desc: string;
  record_set: RecordSetShortView[];
}

export const getPropertyUsagesByPropertySet = (record, column: ColumnToShow) => {
  const psFP = column?.context?.propertySet?.fingerprint;
  if (psFP != null && record != null) {
    const usagesLinked = (record.usages ?? [])
      .filter((usage: UsageShortView) => usage?.record_set?.some((rs: RecordSetShortView) => rs.set_id === psFP))
      .map((usage: UsageShortView) => getPropertyTypeLabel(usage.ref_property_usage_type_desc))
      .join(', ');
    return usagesLinked;
  }
  return '';
};

export const COLUMNS_TO_SHOW: ColumnToShow[] = [
  {
    columnId: 1,
    CellRenderer: OpenInNewComponent,
    header: '',
    field: '__placeholder_open_in_new__',
  },
  {
    columnId: 2,
    CellRenderer: PropertySetStatisticalCellRendererComponent,
    header: '',
    field: 'usages/statistical_f',
  },
  { columnId: 850, header: 'Property Name', field: 'property_name', dataType: 'text', sortable: true },
  { columnId: 4, header: 'Address', field: 'postal_address.full_street_name', dataType: 'text', sortable: true },
  {
    columnId: 5,
    header: 'Property Type',
    field: 'usages/ref_property_usage_type_desc',
    dataType: 'text',
    sortable: true,
    displayFn: (record: Record<string, any>, _s, _m, column: ColumnToShow) =>
      getPropertyUsagesByPropertySet(record, column),
  },
  {
    columnId: 6,
    header: 'NRA - Property Type',
    field: 'usages/net_rentable_area',
    dataType: 'numeric',
    sortable: true,
  },
  { columnId: 7, header: 'Status', field: 'ref_property_status_desc', dataType: 'text', sortable: true },
  { columnId: 8, header: 'Market', field: 'usages/lig_geography.market_desc', dataType: 'text', sortable: true },
  { columnId: 9, header: 'Submarket', field: 'usages/lig_geography.submarket_desc', dataType: 'text', sortable: true },
  { columnId: 10, header: 'Property ID', field: 'entity.id', dataType: 'id', sortable: true },
];
